import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { StockChart } from "angular-highcharts";
import * as Highcharts from "highcharts";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ChartService } from "../../../widget-utilities/chart.service";
import { multiColorThemes } from "../../common/chartThemes";
import { ResizedEvent } from 'angular-resize-event-package';

@Component({
    selector: 'app-basechart',
    templateUrl: './basechart.component.html',
    styleUrls: ['./basechart.component.scss'],
    standalone: false
})

export class BaseChartComponent implements OnInit, OnDestroy {
    @Input() public isInWizard: boolean;
    @Input() data: any[];
    @Input() gridItem: any;
    @Input() isCalls: boolean;
    @Input() type: string;
    @Input() colorSchemeId: number;
    @Input() notifier: Subject<any>;

    public chart: StockChart;
    
    private ngUnsubscribe = new Subject<void>();

  constructor(protected chartService: ChartService) { }

    ngOnInit(): void {
        this.notifier.pipe(takeUntil(this.ngUnsubscribe)).subscribe(value => {
            setTimeout(() => {
                this.createChart();
            }, 0)
        });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    
    createChart(): void {
        // virtual method
    }

    onResized(event: ResizedEvent): void {
        if (this.data && !this.isInWizard) {
            if (this.data.length > 30) {
                this.delay(() => {
                    this.createChart();
                }, 100);
            } else {
                this.createChart();
            }
        }
    }

    delay = (function () {
        let timer: null | ReturnType<typeof setTimeout> = null
        return function (callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        };
    })();
}
